/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelMappingControl.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/mapping-control";

export class AutogenModelMappingControl<RowType extends ModelRow> extends Endpoint<RowType, RowMappingControlFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowMappingControl extends ModelRow<RowMappingControlFields> {
	constructor(values?: Partial<RowMappingControlFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowMappingControlFields {
	always_show_maps: string;
	company_id: string;
	distance_calc_vendor: string;
	driver_manager_vendor: string;
	findnear_vendor: string;
	id: string;
	ltl_mapping_vendor: string;
	mc_position_vendor: string;
	movement_map_vendor: string;
	order_planning_vendor: string;
	order_stop_vendor: string;
	request_location_vendor: string;
	route_detail_vendor: string;
	single_point_vendor: string;
	trip_mgt_vendor: string;
	view_movement_vendor: string;
	web_map: string;
	zone_mapping_vendor: string;
}

